import { DownOutlined, UpOutlined } from '@ant-design/icons'
import { Badge, Button, Flex, List, Space, Typography } from 'antd'
import React, { useMemo } from 'react'
import { useToggle } from 'react-use'

import { ChatterEmployeeEarning } from '@/model/analytics'

import SectionTitle from '../section-title'

const { Text, Link } = Typography

export interface ChatterOverviewSalesRankingProps {
  loading: boolean
  rankings?: ChatterEmployeeEarning[]
}

export default function ChatterOverviewSalesRanking({
  loading,
  rankings = [],
}: ChatterOverviewSalesRankingProps) {
  const [descending, toggle] = useToggle(true)

  const sortedRankings = useMemo(() => {
    return rankings
      .slice(0)
      .sort((a, b) => {
        return descending ? b.earnings - a.earnings : a.earnings - b.earnings
      })
  }, [rankings, descending])

  return (
    <Flex vertical flex={1} gap={8}>
      <Flex justify="space-between">
        <SectionTitle title="Sales ranking" />
        <Button type="text" size="small" onClick={toggle} style={{ fontSize: 12 }}>
          <Space>
            {descending ? 'Descending' : 'Ascending'}
            {descending ? <DownOutlined /> : <UpOutlined />}
          </Space>
        </Button>
      </Flex>
      <List
        style={{ height: 320, overflow: 'auto' }}
        dataSource={sortedRankings}
        loading={loading}
        renderItem={((item, index) => (
          <List.Item style={{ paddingRight: 16, borderBottom: 'none' }}>
            <Flex justify="space-between" flex={1}>
              <Flex gap={8}>
                <Badge count={index + 1} color={index <= 2 ? 'var(--ranking-top-color)' : 'gray'} />
                <Text>{item.name}</Text>
              </Flex>
              <Link>${item.earnings}</Link>
            </Flex>
          </List.Item>
        ))}
      />
    </Flex>
  )
}
